<template>
  <div class="fall_page_area">
       <div class="fall_page_area__bg_img">
            <img src="@/assets/fall/bg.png">
            <div class="first_section" v-if="page==1">
                <div class="first_section__title">
                    <img src="@/assets/fall/title.png"/>
                    <p class="first_section__title_txt">축복이 될 말씀을 뽑아보세요!</p>
                </div>
                <div class="first_section__btn">
                    <img src="@/assets/fall/choice_btn.png" v-on:click="goto_choice()"/>
                </div>
                <div class="first_section__logo">
                    <img src="@/assets/fall/logo2.png"/>
                </div>
            </div>
            <div class="second_section" v-if="page==2">
                <div class="second_section__inner">
                    <img class="bg" src="@/assets/fall/bg2.png"/>
                    <div class="second_section__loading">
                        <img class="loading" src="@/assets/fall/leaves.png"/>
                    </div>
                    <div class="second_section__txt_area">
                        <p class="second_section__txt_area_txt">성구를<br>뽑는 중입니다.</p>
                    </div>
                    <div class="second_section__logo_area">
                        <img src="@/assets/fall/logo.png"/>
                    </div>
                </div>
            </div>
            <div class="third_section" v-if="page==3">
                <div class="transform_area" :class="scroll ? 'on':''">
                    <div class="capture_area">
                        <div class="capture_area__back">
                            <img class="bg" src="@/assets/fall/bg.png"/>
                            <div class="capture_area__inner">
                                <img class="card" src="@/assets/fall/bg2.png"/>
                                <div class="capture_area__title">
                                    <img src="@/assets/fall/title.png"/>
                                </div>
                                <div class="capture_area__verse">
                                    <p class="capture_area__verse_txt">{{print_verse.verse}}</p>
                                    <p class="capture_area__verse_tit">{{print_verse.chapter}}</p>
                                </div>
                                <div class="capture_area__logo">
                                    <img src="@/assets/fall/logo.png"/>
                                </div>
                            </div>
                            <div class="capture_area__arrow">
                                <img src="@/assets/fall/arrow.png" v-on:click="scrollClick()"/>
                            </div>
                        </div>
                    </div>
                    <div class="menu_area">
                        <div class="menu_area__back">
                            <img class="bg" src="@/assets/fall/bg.png"/>
                            <div class="menu_area__title">
                                <img src="@/assets/fall/title.png"/>
                            </div>
                            <ul class="menu_area__list">
                                <li class="menu_area__item" v-on:click="choiceVerse()">
                                    <img src="@/assets/fall/menu_btn.png"/>
                                    <p class="menu_area__txt">말씀다시뽑기</p>
                                </li>
                                <li class="menu_area__item" v-on:click="shareClick()">
                                    <img src="@/assets/fall/menu_btn.png"/>
                                    <p class="menu_area__txt">링크복사하기</p>
                                </li>
                                <li class="menu_area__item" v-on:click="imgSave()">
                                    <img src="@/assets/fall/menu_btn.png"/>
                                    <p class="menu_area__txt">이미지 저장하기</p>
                                </li>
                                <li class="menu_area__item" v-on:click="gotoAnother()">
                                    <img src="@/assets/fall/menu_btn.png"/>
                                    <p class="menu_area__txt">다른테스트하기</p>
                                </li>
                                <li class="menu_area__item" v-on:click="gotoWs()">
                                    <img src="@/assets/fall/menu_btn.png"/>
                                    <p class="menu_area__txt">말씀광장 가보기</p>
                                </li>
                                <li class="menu_area__item" v-on:click="scrollClick()">
                                    <img src="@/assets/fall/menu_btn.png"/>
                                    <p class="menu_area__txt">돌아가기</p>
                                </li>
                            </ul>
                            <div class="menu_area__logo">
                                <img src="@/assets/fall/logo.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
  </div>
</template>

<script>
export default {
    props : ['verse','scroll','page','print_verse'
            ,'goto_choice','scroll_click','share_fun','goto_another','goto_ws','image_save'],
    methods: {
        choiceVerse(){
            this.goto_choice();
        },
        scrollClick(){
            this.scroll_click();
        },
        shareClick(){
            this.share_fun();
        },
        gotoAnother(){
            this.goto_another();
        },
        gotoWs(){
            this.goto_ws();
        },
        imgSave(){
            this.image_save();
        }
    },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/scss/fall.scss';
</style>
